import { COLUMNS } from '../_constants/Columns'

export default {
  getDefaultState: () => {
    return {
      cards: [],
      filters: {},
      currentPage: 1,
      lastPage: 1,
      totalItems: 0,
      isCallingCards: false,
      tableColumns: COLUMNS.CARDS
    }
  }
}
